import React from 'react';
import { CONVERT_CONTENT } from '../../../../pages/CompanyPages/CompanyOverview/CompanyOverview';
import { EMPLOYEE_PROPTYPES } from '../../../Includes/CompanyProps';
import { buildImagePath } from '../../../JobComponents/Company/Image/logo';
import LeftRailLayout from '../../../LeftRailLayout/LeftRailLayout';

import './FgbFeaturedEmployeeSlide.scss';
import ResponsivePicture from '../../../Elements/ResponsivePicture/ResponsivePicture';

export default class FgbFeaturedEmployeeSlide extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        ...EMPLOYEE_PROPTYPES,
    };

    renderImageSection = () => {
        const breakpoints = {
            mobile: { width: 200, height: 200, transforms: { crop: 'limit' } },
        };
        return (
            <div className="employee-image-section">
                <div className="container-div">
                    {this.props.image && this.props.image.src ? (
                        <ResponsivePicture
                            cloudinaryID={this.props.image.src}
                            breakpoints={breakpoints}
                        />
                    ) : null}
                    <div className="name">{this.props.name}</div>
                    <div className="role description">{this.props.role}</div>
                    <div className="location description">
                        {this.props.location}
                    </div>
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="component-CompanyPages-Sections-FgbFeaturedEmployeeSlide">
                <LeftRailLayout mobileLayoutClass={'rail-content-on-top'}>
                    {/** TODO: refactor this not to use leftrail in the component level */}
                    <LeftRailLayout.LeftRail showLegacyRail={true}>
                        {this.renderImageSection()}
                    </LeftRailLayout.LeftRail>
                    <LeftRailLayout.MainContent>
                        <div
                            className="bio-section"
                            dangerouslySetInnerHTML={CONVERT_CONTENT(
                                this.props.bio
                            )}
                        />
                    </LeftRailLayout.MainContent>
                </LeftRailLayout>
            </div>
        );
    }
}
